import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../images/finkoda black.png";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";
import "../../styles/HeaderStyles.css";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle menu toggle
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", position: "relative" }}>
      {/* Close Button */}
      <IconButton
        onClick={handleDrawerToggle}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          color: "#000",
        }}
      >
        <CloseIcon />
      </IconButton>

      <Typography
        color={"#b2f4aa"}
        variant="h6"
        component="div"
        sx={{ flexGrow: 1, my: 2 }}
      >
        {/* <img src={Logo1} alt="logo" height={"32"} width="202" /> */}
      </Typography>

      <ul className="mobile-navigation">
        <li>
          <NavLink className={({ isActive }) => (isActive ? "active" : "")} to={"/"}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to={"/about"} className={({ isActive }) => (isActive ? "active" : "")}>About</NavLink>
        </li>
        <li>
          <NavLink to={"/information"} className={({ isActive }) => (isActive ? "active" : "")}>Information</NavLink>
        </li>
        <li>
          <NavLink to={"/contact"} className={({ isActive }) => (isActive ? "active" : "")}>Contact</NavLink>
        </li>
        <li>

          <Button
            variant="contained"
            href="https://app.finkoda.com/login"
            target="_blank"
            sx={{
              backgroundColor: "#1a7d3b",
              "&:hover": {
                backgroundColor: "#156e29",
              },
              color: "#fff !important", // Enforce white text color
              textTransform: "none",
              ml: 2,
              borderRadius: "40px",
              fontSize: "1rem",
            }}
          >
            Login
          </Button>

        </li>
      </ul>
    </Box>
  );

  return (
    <>
      <Box>
        <AppBar
          component={"nav"}
          sx={{
            bgcolor: isScrolled ? "#e2fbdf" : "#e2fbdf", // Change color on scroll
            transition: "background-color 0.3s ease", // Smooth transition
            boxShadow: isScrolled ? undefined : "none", // Remove shadow when scrolled
            borderBottom: "1px solid rgba(256, 256, 256, .1)"
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              sx={{
                mr: 2,
                display: { sm: "none" },
                color: "black" 
              }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              color={"#b2f4aa"}
              component="div"
              sx={{ flexGrow: 1, textAlign: { xs: "center", sm: "left" } }}
            >
              <img src={Logo} alt="logo" height={"32"} width="202" />
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <ul className="navigation-menu">
                <li>
                  <NavLink className={({ isActive }) => (isActive ? "active" : "")} to={"/"}>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/about"} className={({ isActive }) => (isActive ? "active" : "")}>About</NavLink>
                </li>
                <li>
                  <NavLink to={"/information"} className={({ isActive }) => (isActive ? "active" : "")}>Information</NavLink>
                </li>
                <li>
                  <NavLink to={"/contact"} className={({ isActive }) => (isActive ? "active" : "")}>Contact</NavLink>
                </li>
                <li>
                  <Button
                    variant="contained"
                    href="https://app.finkoda.com/login"
                    target="_blank"
                    sx={{
                      backgroundColor: "#1a7d3b",
                      "&:hover": {
                        backgroundColor: "#156e29",
                      },
                      color: "#fff !important", // Enforce white text color
                      textTransform: "none",
                      ml: 2,
                      borderRadius: "40px",
                      fontSize: "1rem",
                    }}
                  >
                    Login
                  </Button>
                </li>
              </ul>
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "240px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Box>
          <Toolbar />
        </Box>
      </Box>
    </>
  );
};

export default Header;

